<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.category_name"
            placeholder="分类名称"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="编号"
      >
        <template slot-scope="scope">
          {{scope.row.serial_number}}
        </template>
      </el-table-column>
      <el-table-column
        label="分类名称"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.category_name}}
        </template>
      </el-table-column>
      <el-table-column
        label="级别"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.level}}
        </template>
      </el-table-column>

      <el-table-column
              label="商品数量"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.shop_quantity}}
        </template>
      </el-table-column>
      <el-table-column
              label="排序"
              prop="sort_id"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.category_sort}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"  @click="openEditForm(scope.row)">修改</el-button>
          <el-button type="primary" plain  size="mini"  @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
    import util from '@/libs/util.js'
export default {
  name: "GoodstypePage",
  components: { editForm },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getGoodsTypePageList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService
          .delGoodsTypes({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delGoodsType({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
